module.exports = __webpack_public_path__ + "img/pausenzeitung-v2.eda0fae1.png";